<template>
    <div class="page-report">
      <div class="row mb-2 pe-4">
        <div class="col-lg-12 col-md-12 col-12 d-flex align-items-center">
          <div class="color-common">
            <h3 class="title-page mb-0 ps-3">MEGAPOS DATA</h3>
          </div>
        </div>
      </div>
      <div class="page-header align-items-start min-vh-100 my-transacions">
        <span class="mask bg-white"></span>
        <div class="container">
          <div class="row">
            <div class="col-lg-12 col-md-12 col-12 mx-auto mt-4">
              <div class="row">
                <h2> Item Sales By Group</h2>
              </div>
              <FormSearch
                :searchParameter="form"
                :onChangeSearchParameter="onChangeSearchParameter"
                :selectAllBranch="false"
                :hidePhysicalBranchFilter="false"
                :onlySelectMonth="false"
                :selectAllPhysicalBranch="true"
                @reload-data="getList"
                @export="exportFile"
              ></FormSearch>
              <div class="row mt-4" v-if="isLoadDone" v-show="isLoadDoneDataTable">
                <div class="col-12">
                  <div>
                    <div class="px-0 pb-2">
                      <div class="p-0 custom-table">
                        <table :key="tableRenderKey" class="table align-items-center mb-0 dataTable" ref="dataTable">
                          <thead>
                            <tr>
                              <th class="text-center font-weight-bolder">
                                <div class="pt-4">Row No</div>
                              </th>
                              <template
                                v-for="(item, index) in headersData"
                                :key="index"
                              >
                                <th class="text-center font-weight-bolder position-relative">
                                  <div
                                    class="pt-4"
                                    style="position: unset;"
                                    :class="[
                                      !!item.hasSortBy
                                        ? 'wrapper-sortby pointer'
                                        : '',
                                      ESortDirectionSelect.idx == index + 1
                                        ? ESortDirectionSelect.direction ===
                                          ESortDirection.Desc
                                          ? 'sort-desc'
                                          : 'sort-asc'
                                        : '',
                                    ]"
                                    @click="handleChangeSortColumn(index + 1, item.field)"
                                    >{{ item.label }}</div
                                  >
                                </th>
                              </template>
                              <th class="text-center font-weight-bolder position-relative" v-for="(group, index) in groups" :key="headersData.length + (index + 1)">
                                <div
                                    class="pt-4"
                                    style="position: unset;"
                                    :class="[
                                      'wrapper-sortby pointer',
                                      ESortDirectionSelect.idx == headersData.length + (index + 1)
                                        ? ESortDirectionSelect.direction ===
                                          ESortDirection.Desc
                                          ? 'sort-desc'
                                          : 'sort-asc'
                                        : '',
                                    ]"
                                    @click="handleChangeSortColumn(headersData.length + (index + 1), 'group', index)"
                                    >{{ group }}</div
                                  >
                              </th>
                              <th class="text-center font-weight-bolder position-relative">
                                <div
                                    class="pt-4"
                                    style="position: unset;"
                                    :class="[
                                      'wrapper-sortby pointer',
                                      ESortDirectionSelect.idx == headersData.length + groups.length + 1
                                        ? ESortDirectionSelect.direction ===
                                          ESortDirection.Desc
                                          ? 'sort-desc'
                                          : 'sort-asc'
                                        : '',
                                    ]"
                                    @click="handleChangeSortColumn(headersData.length + groups.length + 1, 'total')"
                                    >Total</div
                                  >
                              </th>
                            </tr>
                            <tr>
                              <th class="text-center font-weight-bolder">
                                <input
                                  v-model="columnSearch[0]"
                                  @input="searchColumn(0)"
                                />
                              </th>
                              <template
                                v-for="(item, index) in headersData"
                                :key="index"
                              >
                                <th class="text-center font-weight-bolder">
                                  <input
                                    v-model="columnSearch[index + 1]"
                                    @input="searchColumn(index + 1)"
                                  />
                                </th>
                              </template>
                              <th class="text-center font-weight-bolder" v-for="(group, index) in groups" :key="headersData.length + (index + 1)">
                                <input
                                  v-model="
                                    columnSearch[headersData.length + (index + 1)]
                                  "
                                  @input="searchColumn(headersData.length + (index + 1))"
                                />
                              </th>
                              <th class="text-center font-weight-bolder">
                                <input
                                  v-model="columnSearch[headersData.length + groups.length + 1]"
                                  @input="searchColumn(headersData.length + groups.length + 1)"
                                />
                              </th>
                            </tr>
                          </thead>
                          <tbody v-if="dataRows.length">
                            <tr
                              v-for="(value, key) in dataRows"
                              :key="key"
                            >
                              <td class="text-right text-xss">
                                {{ key + 1 }}
                              </td>
                              <td class="text-left text-xss">
                                {{ value.date }}
                              </td>
                              <td class="text-right text-xss" v-for="(group, index) in value.groups" :key="index">
                                {{ formatQty(group.qty) }}
                              </td>
                              <td class="text-right text-xss">
                                {{ formatQty(value.total) }}
                              </td>
                            </tr>
                          </tbody>
                          <tbody v-else>
                            <tr>
                              <td :colspan="3 + groups.length" class="text-left">
                                No matching records found
                              </td>
                            </tr>
                          </tbody>
                          <tfoot>
                            <tr class="total-row">
                              <td class="text-right text-xss">TOTAL</td>
                              <td></td>
                              <td class="text-right text-xss" v-for="(group, index) in groups" :key="'tf-' + index"></td>
                              <td class="text-right text-xss"></td>
                            </tr>
                          </tfoot>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="position-fixed top-1 end-1 z-index-2 message-success">
          <material-snackbar
            v-if="snackbar === 'danger' || snackbar === 'success'"
            title=""
            date=""
            :description="message"
            :icon="{ component: 'campaign', color: 'white' }"
            :color="snackbar"
            :close-handler="closeSnackbar"
          />
        </div>
        <material-loading :active="loaderActive" />
      </div>
      <form
        :action="`${actionDownload}/merchant/analytics/item-sales-by-group-daily/export`"
        method="POST"
      >
        <input type="hidden" name="merchantId" :value="merchantIdExport" />
        <input type="hidden" name="merchant_code" :value="merchantCode" />
        <input type="hidden" name="token" :value="token" />
        <input type="hidden" name="physical_branch_id" :value="form.physical_branch_id" />
        <input type="hidden" name="from_date" :value="from_date_export" />
        <input type="hidden" name="to_date" :value="to_date_export" />
        <input type="hidden" name="action_export" :value="action_export" />
        <input type="hidden" name="action" value="export" />
        <input id="downloadForm" type="submit" class="d-none" />
      </form>
    </div>
  </template>

  <script>
  import MaterialSnackbar from "@/components/MaterialSnackbar.vue";
  import "bootstrap/dist/js/bootstrap.bundle";
  import MaterialLoading from "@/components/MaterialLoading.vue";
  import "bootstrap/js/dist/modal";
  import "@vuepic/vue-datepicker/dist/main.css";
  import "@vueform/multiselect/themes/default.css";
  import "@vuepic/vue-datepicker/dist/main.css";
  import moment from "moment";
  import AnalyticsService from "../../services/analytics.service";
  import CommonFunctionService from "../../services/commonFunction.service";
  import { startOfMonth } from "date-fns";
  import $ from "jquery";
  import TokenService from "../../services/token.service";
  import FormSearch from "../analytics/components/FormSearch.vue";
  import { SEARCH_FIELD } from "./mock_data";
  import "datatables.net";

  export default {
    name: "item-sales-by-group-daily-report",
    components: {
      MaterialSnackbar,
      MaterialLoading,
      FormSearch
    },
    data() {
      return {
        isLoadDone: false,
        isLoadDoneDataTable: false,
        token: TokenService.getLocalAccessToken(),
        actionDownload: process.env.VUE_APP_BASE_URL,
        merchantIdExport: localStorage.getItem("MERCHANT_ID", ""),
        merchantCode: localStorage.getItem("MERCHANT_CODE", ""),
        message: "",
        snackbar: null,
        loaderActive: false,
        dailyItemSales: [],
        form: {
          physical_branch_id: -1,
          branch_id: -1,
          from_date: moment(startOfMonth(new Date())),
          to_date: new Date(),
        },
        ESortDirectionSelect: {
          idx: null,
          field: '',
          direction: null,
        },
        ESortDirection: {
          Asc: "asc",
          Desc: "desc",
        },
        groups: [],
        action_export: 'csv',
        from_date_export: "",
        to_date_export: "",
        dataTable: null,
        columnSearch: [],
        // The number of group columns changes with the query (different date ranges
        // sell different groups), unlike the fairly stable payment-method columns this
        // report's layout was copied from. jQuery DataTables restructures the table's
        // DOM on init; when the column count then changes on the next load, Vue's own
        // patch of the same <table> conflicts with what DataTables left behind and
        // throws "insertBefore" on a stale node. Bumping this key forces Vue to fully
        // discard and remount the <table> on every load instead of patching it in place.
        tableRenderKey: 0
      };
    },
    computed: {
      // The server appends a grand-total as the last element; the visible total
      // now lives in the table footer and is recomputed from the filtered rows,
      // so the body renders only the real data rows.
      dataRows() {
        return this.dailyItemSales.length
          ? this.dailyItemSales.slice(0, -1)
          : [];
      },
      headersData() {
        return [
          {
            label: "Date",
            field: "date",
            hasSortBy: true,
          },
        ];
      },
    },
    methods: {
      format(date) {
        return CommonFunctionService.formatDateShow(date);
      },

      formatQty(qty) {
        qty = parseInt(qty) || 0;
        return qty.toLocaleString('en-US');
      },

      exportFile(type = "csv") {
        this.action_export = type;
        this.from_date_export = this.dateFormat(this.form.from_date);
        this.to_date_export = this.dateFormat(this.form.to_date);
        setTimeout(() => {
          $("#downloadForm").click();
        }, 150);
      },

      dateFormat(date) {
        if (date == null) {
          return null;
        } else {
          return moment(date).format("YYYY-MM-DD");
        }
      },

      onChangeSearchParameter(value, fieldName) {
        this.form[fieldName] = value !== null ? value : (fieldName == SEARCH_FIELD.MONTH ? "" : "-1");
      },

      closeSnackbar() {
        this.snackbar = null;
      },

      setTimeOutNotification() {
        setTimeout(() => {
          this.snackbar = null;
        }, 3000);
      },

      initializeDataTable() {
        const self = this;
        this.dataTable = $(this.$refs.dataTable).DataTable({
          paging: false,
          searching: true,
          ordering: false,
          info: false,
          // Recompute the footer total from the rows matching the current
          // search on every draw, so the total row stays visible and reflects
          // only the filtered rows.
          footerCallback: function () {
            const api = this.api();
            const parseNum = (v) => {
              if (v === null || v === undefined) return 0;
              const n = parseFloat(String(v).replace(/[^0-9.-]/g, ""));
              return isNaN(n) ? 0 : n;
            };
            const sumCol = (idx) =>
              api
                .column(idx, { search: "applied" })
                .data()
                .reduce((acc, val) => acc + parseNum(val), 0);

            const footer = $(api.table().footer());
            if (!footer.length) return;
            const cells = footer.find("td");

            // Group qty columns: index 2 .. 1 + groups.length
            for (let c = 2; c < 2 + self.groups.length; c++) {
              cells.eq(c).html(self.formatQty(sumCol(c)));
            }

            // Total column (last)
            const totalColIdx = 2 + self.groups.length;
            cells.eq(totalColIdx).html(self.formatQty(sumCol(totalColIdx)));
          },
        });
      },

      searchColumn(index) {
        this.dataTable.column(index).search(this.columnSearch[index]).draw();
      },

      handleChangeSortColumn(idx, field, group_idx = 0) {
        if (
          this.ESortDirectionSelect.idx &&
          this.ESortDirectionSelect.idx == idx
        ) {
          this.ESortDirectionSelect.direction =
            this.ESortDirectionSelect.direction === this.ESortDirection.Asc
              ? this.ESortDirection.Desc
              : this.ESortDirection.Asc;
        } else {
          this.ESortDirectionSelect = {
            idx: idx,
            field: field,
            direction: this.ESortDirection.Asc,
          };
        }


        const direction = this.ESortDirectionSelect.direction;
        const totalRow = this.dailyItemSales.pop();

        this.dailyItemSales.sort(function(item, item2) {
          if (field == "group") {
            if (direction == "asc") {
              if (item.groups[group_idx]?.qty > item2.groups[group_idx]?.qty) return 1;
              if (item.groups[group_idx]?.qty < item2.groups[group_idx]?.qty) return -1;
            }

            if (direction == "desc") {
              if (item.groups[group_idx]?.qty < item2.groups[group_idx]?.qty) return 1;
              if (item.groups[group_idx]?.qty > item2.groups[group_idx]?.qty) return -1;
            }

            return 0;
          } else {
            if (direction == "asc") {
              if (item[field] > item2[field]) return 1;
              if (item[field] < item2[field]) return -1;
            }

            if (direction == "desc") {
              if (item[field] < item2[field]) return 1;
              if (item[field] > item2[field]) return -1;
            }

            return 0;
          }
        });

        this.dailyItemSales.push(totalRow);

        // The sort mutated the array and Vue re-rendered the same DOM nodes with
        // new content. Re-read the DOM into DataTables (after the patch) so its
        // cache — used by column search and the footer total — matches what's
        // actually displayed; otherwise a search matches stale, pre-sort rows.
        this.$nextTick(() => {
          if (this.dataTable) {
            this.dataTable.rows().invalidate("dom").draw(false);
          }
        });
      },

      getList() {
        this.showLoader();
        var dataForm = {
          physical_branch_id: this.form.physical_branch_id,
          from_date: this.dateFormat(this.form.from_date),
          to_date: this.dateFormat(this.form.to_date),
        };

        AnalyticsService.itemSalesByGroupDailyReport(dataForm).then(
          (response) => {
            if (response.data.result.isSuccess) {
              // Tear down the previous DataTable before swapping in new data so the
              // rows update in place — the table stays visible under the loader.
              if (this.dataTable) {
                this.dataTable.destroy();
                this.dataTable = null;
              }

              // Force a full remount of the <table> (see tableRenderKey above) rather
              // than letting Vue patch the DOM DataTables just tore down.
              this.tableRenderKey++;

              this.dailyItemSales = response.data.data.daily_item_sales;
              this.groups = response.data.data.groups;
              const totalColumn = this.headersData.length + this.groups.length + 1;
              this.columnSearch = [''];

              for (let i = 0; i < totalColumn; i++) {
                this.columnSearch.push("");
              }

              this.isLoadDone = true;

              this.$nextTick(() => {
                this.initializeDataTable();
                this.isLoadDoneDataTable = true;
                this.hideLoader();
              });
            } else {
              this.snackbar = "danger";
              this.message = response.data.result.message;
              this.setTimeOutNotification();
              this.hideLoader();
            }
          },
          (error) => {
            this.snackbar = "danger";
            this.message = error;
            this.hideLoader();
            this.setTimeOutNotification();
          }
        );
      },

      showLoader() {
        this.loaderActive = true;
      },

      hideLoader() {
        this.loaderActive = false;
      },
    },
  };
  </script>
  <style scoped>
  table thead th:not(:first-child) {
    padding-left: 10px !important;
    padding-right: 10px !important;
  }

  table thead th > span {
    position: relative;
  }

  input[type="search"] {
    border: none;
    background: transparent;
    margin: 0;
    padding: 7px 8px;
    font-size: 14px;
    color: inherit;
    border: 1px solid transparent;
    border-radius: inherit;
  }

  input[type="search"]::placeholder {
    color: #bbb;
    text-align: left;
    font-weight: normal;
  }

  input[type="search"]:focus {
    border-color: #72959d;
    outline: none;
    border: none;
    border-bottom: 2px solid #72959d;
  }

  .nosubmit-parent {
    border: none;
    padding: 0;
  }

  input.nosubmit {
    border-bottom: 1px solid #d2d2d2;
    width: 100%;
    padding: 9px 4px 9px 40px;
    background: transparent
      url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' class='bi bi-search' viewBox='0 0 16 16'%3E%3Cpath d='M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z'%3E%3C/path%3E%3C/svg%3E")
      no-repeat 13px center;
  }

  .date-time-dashboad .dp__input_wrap {
    min-width: 200px !important;
    width: 250px;
  }

  .custom-control-label label {
    padding-top: 14px !important;
  }

  .pt-custtom {
    padding-top: 7px;
  }

  tbody:not(.no-data) > tr:nth-child(2n + 1) {
    background: #f0f2f5;
  }

  tbody:not(.no-data) > tr:hover {
    background: #ebecee;
  }

  tr.total-row {
    font-weight: bold;
    color: #222;
  }


  .custom-table :not(caption)>*>* {
      border-right-width: 1px !important;
  }

  .custom-table :not(caption)>*>*:first-child {
      border-left-width: 1px !important;
  }

  /* Fit the section within the viewport (minus the title bar) so the page itself
     doesn't scroll — the table region handles its own scrolling instead */
  .page-header.my-transacions {
    min-height: calc(100vh - 70px) !important;
  }

  /* Scroll only the table region so the page stays put; cap height to the viewport */
  .custom-table :deep(.dt-layout-table > .dt-layout-cell) {
    max-height: calc(100vh - 360px);
    overflow: auto;
  }

  /* Separate borders so the grid lines travel with the sticky header/total row */
  .custom-table table.dataTable {
    border-collapse: separate;
    border-spacing: 0;
  }

  .custom-table table.dataTable th,
  .custom-table table.dataTable td {
    border-right: 1px solid #dee2e6;
    border-bottom: 1px solid #dee2e6;
  }

  .custom-table table.dataTable th:first-child,
  .custom-table table.dataTable td:first-child {
    border-left: 1px solid #dee2e6;
  }

  .custom-table table.dataTable thead tr:first-child th {
    border-top: 1px solid #dee2e6;
  }

  /* Keep the header (both rows) fixed at the top while scrolling */
  .custom-table table.dataTable thead {
    position: sticky;
    top: 0;
    z-index: 3;
  }

  .custom-table table.dataTable thead th {
    background: #fff;
  }

  /* Keep the total row fixed at the bottom */
  .custom-table table.dataTable tfoot tr.total-row td {
    position: sticky;
    bottom: 0;
    z-index: 2;
    background: #e9edf2;
    border-top: 1px solid #dee2e6;
  }
  </style>
